/**
 * @packageDocumentation
 * @module f1/adt
 */

import { t_rec_open } from '../types';

/**
 * Used to decide how to shrink a dictionary
 * @protected
 * @ignore
 */
type ho_fn_shrink_by = (value: unknown) => boolean;

export interface Shrink {
  /**
   * Remove (shallow) keys from a dictionary by a rule
   *
   * @public
   * @function shrink
   * @param rule
   * @param dictionary
   * @example
   *
   * ```ts
   * shrink({value: 'ebvk', fgs: undefined,}); // => {value: 'ebvk'}
   * ```
   */
  <BY extends ho_fn_shrink_by, D extends t_rec_open, R extends t_rec_open>(rule: BY, dictionary: D): R;
  /**
   * {@link FnShrinkValue}
   * @param value
   */
  <BY extends ho_fn_shrink_by, D extends t_rec_open, R extends t_rec_open>(rule: BY): (dictionary: D) => R;
}

/**
 * @see Shrink
 */
export default (by: ho_fn_shrink_by, dictionary: t_rec_open) =>
  Object.keys(dictionary).reduce((acc, a) => Object.assign(acc, by(dictionary[a]) ? { [a]: dictionary[a] } : {}), {});
